export class EventCollisionModalConfig {

  content: string;
  cancel: string;
  confirm: string;
  title: string;
  heading: string;
  closed: (value: any) => void;

  constructor(
    content?: string,
    cancel?: string,
    confirm?: string,
    title?: string,
    heading?: string,
    closed?: (value: any) => void
  ) {
    this.content = content;
    this.cancel = cancel;
    this.confirm = confirm;
    this.title = title;
    this.heading = heading;
    this.closed = closed;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal-config.ts